window.addEventListener("load", function() {

	const embeddedSizeChartTrigger = document.querySelector('#opensizechart');
	const sideTriggerForSizeChart = document.querySelector('#js-fit-guide-popup');
	const sizeChartClose = document.querySelector('#sizeChartClose');

	// open popup using "What size should I order?"
	if(embeddedSizeChartTrigger) {
		embeddedSizeChartTrigger.addEventListener('click', function() {
			document.querySelector('.dynamic-fit-guide').classList.add('show-display');
			document.querySelector('.overlay').classList.add('active');
	
			const expired = new Date().getTime() + 86400;
			localStorage.setItem('sizeChartModal', 'dismissed', expired);
	
			document.querySelector('body').classList.add('chart-active');
		})
	}
	

	// open popup for the side trigger "Size Guide"
	if (sideTriggerForSizeChart) {
		sideTriggerForSizeChart.addEventListener('click', function() {
			document.querySelector('.dynamic-fit-guide').classList.add('show-display');
			document.querySelector('.overlay').classList.add('active');
	
			const expired = new Date().getTime() + 86400;
			localStorage.setItem('sizeChartModal', 'dismissed', expired);
	
			document.querySelector('body').classList.add('chart-active');
		})
	};

	// auto appear "Size Guide" on the side
	if (document.querySelector('.template-product')) {
		setTimeout( function(){ 
			if (document.querySelector('#js-fit-guide-popup')) {
				document.querySelector('#js-fit-guide-popup').style.display = 'block';
			}
		}, 30000 );
	}

	// close event
	if (sizeChartClose) {
		sizeChartClose.addEventListener('click', function(e) {
			e.preventDefault();
			if(embeddedSizeChartTrigger && localStorage.getItem('sizeChartModal') != 'dismissed') {
				const expired = new Date().getTime() + 86400;

				embeddedSizeChartTrigger.style.display = "none";
				localStorage.setItem('sizeChartModal', 'dismissed', expired);
			}
		});
	}
});


document.querySelector('#shoeSize').addEventListener('change',function(){
	let shoeSizeValue = document.querySelector('#shoeSize').value;
	let shoeWidthValue = document.querySelector('#shoeWidth').value;

    if ( shoeSizeValue && shoeWidthValue !== 'select') {
		let recommendedShoeSize;
		let sizeChart;
		let cleanedParse;
		let recommendedString = '<p id="fortressSize">Unfortunately, this style is not available in your size at this time.</p>';

		let shoppersShoeSize = shoeSizeValue;
		if (!document.getElementById('dynamic-fit-guide').getAttribute('data-sizes')) {
			sizeChart =
				{
					"4.5": {
						"n": "",
						"r": "",
						"w": "35"
					},
					"5" : {
						"n": "35",
						"r": "35",
						"w": "35"
					},
					"5.5": {
						"n": "35",
						"r": "35",
						"w": "36"
					},
					"6": {
						"n": "36",
						"r": "36",
						"w": "36"
					},
					"6.5": {
						"n": "36",
						"r": "36",
						"w": "37"
					},
					"7": {
						"n": "37",
						"r": "37",
						"w": "37"
					},
					"7.5": {
						"n": "37",
						"r": "37",
						"w": "38"
					},
					"8" : {
						"n": "38",
						"r": "38",
						"w": "38"
					},
					"8.5": {
						"n": "38",
						"r": "38",
						"w": "39"
					},
					"9": {
						"n": "39",
						"r": "39",
						"w": "39"
					},
					"9.5": {
						"n": "39",
						"r": "39",
						"w": "40"
					},
					"10": {
						"n": "40",
						"r": "40",
						"w": "40"
					},
					"10.5": {
						"n": "41",
						"r": "41",
						"w": "41"
					},
					"11" : {
						"n": "41",
						"r": "41",
						"w": ""
					},
					"11.5": {
						"n": "",
						"r": "",
						"w": ""
					},
					"12": {
						"n": "",
						"r": "",
						"w": ""
					}
				};
			cleanedParse = sizeChart;
		} else {
			sizeChart = document.getElementById('dynamic-fit-guide').getAttribute('data-sizes');
			let cleanedSizesObject = sizeChart.replace(/=>/g, ': ');
			cleanedParse = JSON.parse(cleanedSizesObject);
		}

		// if their size exists in the array
		if (cleanedParse[shoppersShoeSize]) {
			let sizeVariants = cleanedParse[shoppersShoeSize];

			// if they've set the width
			const shopperShoeWidth = shoeWidthValue;

			// assign the right size
			if (shopperShoeWidth === 'narrow' ) {
				if (sizeVariants['n']) {
					recommendedShoeSize = sizeVariants['n'];
					recommendedString = '<p id="fortressSize">We recommend <strong>size ' + recommendedShoeSize + '</strong>.</p>';
				}
			} else if (shopperShoeWidth === 'medium') {
				if (sizeVariants['r']) {
					recommendedShoeSize = sizeVariants['r'];
					recommendedString = '<p id="fortressSize">We recommend <strong>size ' + recommendedShoeSize + '</strong>.</p>';
				}
			} else {
				if (sizeVariants['w']) {
					recommendedShoeSize = sizeVariants['w'];
					recommendedString = '<p id="fortressSize">We recommend <strong>size ' + recommendedShoeSize + '</strong>.</p>';
				}
			}
		}
		document.querySelector('#fortressSize').innerHTML = recommendedString;
	}
});

document.querySelector('#shoeWidth').addEventListener('change',function(){
	let shoeSizeValue = document.querySelector('#shoeSize').value;
	let shoeWidthValue = document.querySelector('#shoeWidth').value;
	
	if ( shoeWidthValue && shoeSizeValue !== 'select') {
		let recommendedShoeSize;
		let sizeChart;
		let cleanedParse;
		let recommendedString = '<p id="fortressSize">Unfortunately, this style is not available in your size at this time.</p>';

		let shoppersShoeSize = shoeSizeValue;
		if (!document.getElementById('dynamic-fit-guide').getAttribute('data-sizes')) {
			sizeChart =
				{
					"4.5": {
						"n": "",
						"r": "",
						"w": "35"
					},
					"5" : {
						"n": "35",
						"r": "35",
						"w": "35"
					},
					"5.5": {
						"n": "35",
						"r": "35",
						"w": "36"
					},
					"6": {
						"n": "36",
						"r": "36",
						"w": "36"
					},
					"6.5": {
						"n": "36",
						"r": "36",
						"w": "37"
					},
					"7": {
						"n": "37",
						"r": "37",
						"w": "37"
					},
					"7.5": {
						"n": "37",
						"r": "37",
						"w": "38"
					},
					"8" : {
						"n": "38",
						"r": "38",
						"w": "38"
					},
					"8.5": {
						"n": "38",
						"r": "38",
						"w": "39"
					},
					"9": {
						"n": "39",
						"r": "39",
						"w": "39"
					},
					"9.5": {
						"n": "39",
						"r": "39",
						"w": "40"
					},
					"10": {
						"n": "40",
						"r": "40",
						"w": "40"
					},
					"10.5": {
						"n": "41",
						"r": "41",
						"w": "41"
					},
					"11" : {
						"n": "41",
						"r": "41",
						"w": ""
					},
					"11.5": {
						"n": "",
						"r": "",
						"w": ""
					},
					"12": {
						"n": "",
						"r": "",
						"w": ""
					}
				};
			cleanedParse = sizeChart;
		} else {
			sizeChart = document.getElementById('dynamic-fit-guide').getAttribute('data-sizes');
			let cleanedSizesObject = sizeChart.replace(/=>/g, ': ');
			cleanedParse = JSON.parse(cleanedSizesObject);
		}

		// if their size exists in the array
		if (cleanedParse[shoppersShoeSize]) {
			let sizeVariants = cleanedParse[shoppersShoeSize];

			// if they've set the width
			const shopperShoeWidth = shoeWidthValue;

			// assign the right size
			if (shopperShoeWidth === 'narrow' ) {
				if (sizeVariants['n']) {
					recommendedShoeSize = sizeVariants['n'];
					recommendedString = '<p id="fortressSize">We recommend <strong>size ' + recommendedShoeSize + '</strong>.</p>';
				}
			} else if (shopperShoeWidth === 'medium') {
				if (sizeVariants['r']) {
					recommendedShoeSize = sizeVariants['r'];
					recommendedString = '<p id="fortressSize">We recommend <strong>size ' + recommendedShoeSize + '</strong>.</p>';
				}
			} else {
				if (sizeVariants['w']) {
					recommendedShoeSize = sizeVariants['w'];
					recommendedString = '<p id="fortressSize">We recommend <strong>size ' + recommendedShoeSize + '</strong>.</p>';
				}
			}
		}

		document.querySelector('#fortressSize').innerHTML = recommendedString;
	}
});


document.querySelector('.overlay').addEventListener('click', function() {
	document.querySelector('.overlay').classList.remove('active');
	document.querySelector('#dynamic-fit-guide').classList.remove('show-display');
});

document.querySelector('.size-chart-close-btn').addEventListener('click', function(e) {
	e.preventDefault();
	document.querySelector('.overlay').classList.remove('active');
	document.querySelector('#dynamic-fit-guide').classList.remove('show-display');
});
